import * as R from "ramda";
import { ENUM_CURRENCY, ENUM_USER_ROLE } from "../../enums";
import { store } from "../../store";
import { CONST_SERVER_ERROR_CODES, GLOBAL_TEXT } from "../../constants";
import moment from "moment";
import { formatDate } from "./date-and-time.utils";

export const createDummyArray = (length) => {
  return Array.from(Array(length).keys());
};

export const convertToFullName = (data) => {
  return `${data?.firstName || ""} ${data?.lastName || ""}`;
};

export const convertToCompanyAndTitleName = (data) => {
  const role = store.getState()?.auth?.user?.role;

  return role === ENUM_USER_ROLE.AMBASSADOR ? data?.company : data?.title;
};

export const convertToCountryCityState = (data) => {
  return `${data?.city}${data?.state ? ` ${data?.state}` : ""}, ${data?.country
    }`;
};

export function amountFormat(number, options = {}) {
  if (!number) number = 0;

  return new Intl.NumberFormat("en-US", {
    currency: ENUM_CURRENCY.USD,
    style: "currency",
    maximumFractionDigits: 0,
    signDisplay: "never",
    ...options,
  })?.format(number);
}

export const getResErrorMsg = (error) => {
  let message = R.pathOr(false, ["response", "data", "message"], error);
  const responseStatus = R.pathOr(false, ["response", "status"])(error);
  const customErrorCode = R.pathOr(false, ["response", "data", "code"])(error);
  const isCustom = R.pathOr(false, ["response", "data", "isCustom"])(error);

  if (customErrorCode && isCustom) {
    if (customErrorCode === "TIME_SLOT_CONFLICT") {
      const conflictSlot = R.path(["response", "data", "conflictSlot"])(error);
      const fromRaw = conflictSlot?.from ?? conflictSlot?.start;
      const toRaw = conflictSlot?.to ?? conflictSlot?.end;
      const slotFormat = "D MMM YYYY h:mm a";
      const errorMessage = CONST_SERVER_ERROR_CODES[customErrorCode];

      if (
        fromRaw &&
        toRaw &&
        moment(fromRaw).isValid() &&
        moment(toRaw).isValid()
      ) {
        return {
          message: GLOBAL_TEXT.ALERT_MESSAGES.TIME_SLOT_CONFLICT_USER_MESSAGE.replace(
            /\{from\}/g,
            formatDate(fromRaw, slotFormat)
          ).replace(/\{to\}/g, formatDate(toRaw, slotFormat)),
          responseStatus,
        };
      }

      return { message: errorMessage, responseStatus };
    }

    const errorMessage = CONST_SERVER_ERROR_CODES[customErrorCode];
    return { message: errorMessage, responseStatus };
  }

  if (message) {
    return { message, responseStatus };
  }

  if (!message && responseStatus === 422) {
    return { message: "", responseStatus };
  }

  message = R.pathOr(R.pathOr("Unknown server error", ["message"], error), [
    "response",
    "data",
    "error",
    "message",
  ])(error);

  if (message === "jwt malformed") {
    return "you were logged out";
  }

  if (message === "Network Error")
    return "Something went wrong with connection";

  if (responseStatus > 400) {
    if (
      responseStatus === 404 &&
      message !== "Request failed with status code 404"
    )
      return "Not found it";
    if (responseStatus === 400) return "Bad request, try to inform developers";
  }

  return { message, responseStatus };
};

export function formatNumberWithCommas(input: string | number) {
  const number = String(input).split(".")[0]; 
  const [integerPart] = number.split(".");

  
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  return formattedIntegerPart;
}

export function checkIsNoInitialConfigRequiredRoutes() {
  const noInitialConfigRequiredRoutes = [
    "review-report",
    "typeform",
    "meeting-summary",
    "microsite-integration",
    "project/invitation-decline",
  ];
  let isNoInitialConfigRequiredRoutes = false;

  for (const route of noInitialConfigRequiredRoutes) {
    if (window && window.location.pathname.startsWith(`/${route}`)) {
      isNoInitialConfigRequiredRoutes = true;
      break;
    }
  }

  return isNoInitialConfigRequiredRoutes;
}

export function convertToHTTPSURL(url) {
  if (!url?.startsWith("http://") && !url?.startsWith("https://")) {
    url = "https://" + url;
  }
  return url;
}

export const removeUrlParams = (
  setSearchParams: any,
  keysToRemove: string[]
) => {
  setSearchParams(
    (prev: URLSearchParams) => {
      const next = new URLSearchParams(prev);
      keysToRemove.forEach((key) => next.delete(key));
      return next;
    },
    { replace: true }
  );
};
